import { ArrowsClockwiseIcon } from '@phosphor-icons/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useGetMarketShopRestaurantOrders } from '@/api/market-shop-restaurant/get-market-shop-restaurant-orders'
import { Button } from '@/components/business/market-shop-restaurant/button'
import { Icon } from '@/components/ui/icon'
import { ELEVATEOS_LOGO_ALT } from '@/constants'

import * as S from './header.styled'

export const Header = () => {
  const { t } = useTranslation(['market-shop-restaurant'])
  const { refetch, isFetching } = useGetMarketShopRestaurantOrders()

  const handleRefreshClick = () => {
    void refetch()
  }

  return (
    <S.Header>
      <S.Logo src="/images/logo/elevateos-logo-wide-black.svg" alt={ELEVATEOS_LOGO_ALT} />
      <Button use="secondary" size="large" loading={isFetching} onClick={handleRefreshClick}>
        {t('market-shop-restaurant:header.refresh')}
        <Icon icon={ArrowsClockwiseIcon} size="2.4rem" />
      </Button>
    </S.Header>
  )
}
